import React from "react"
import { PlayerIdentity, entryUser } from "components/ReviewAudit/PublicRatings"
import { participantLocation } from "./participantDisplay"
import { getParticipantGameLevel } from "./participantLevel"
import { participantDescription } from "./ParticipantOption"

// The choices of a slot's Replace / Swap. A Tenis10 child (profileId) is offered by its name and its parent — never with the parent's
// levels or city (PRD 16 LR11b, register E39 (1)); an adult with its levels and city.
export const replacementPeople = entry => [entryUser(entry), entry?.partner].filter(Boolean)
const replacementName = person => [person?.firstName, person?.lastName].filter(Boolean).join(" ") || "Participant"
const replacementFacts = person => [
  `Lvl-S: ${getParticipantGameLevel(person, "singles") ?? "—"}`,
  `Lvl-D: ${getParticipantGameLevel(person, "doubles") ?? "—"}`,
  participantLocation(person?.location).city,
].filter(Boolean).join(" · ")
const replacementText = person => person.profileId ? participantDescription(person) : `${replacementName(person)} #${person.userId} ${replacementFacts(person)}`

export const replacementOption = entry => entry.type === "BYE"
  ? { label: "BYE", value: entry }
  : { value: entry, label: replacementPeople(entry).map(replacementText).join(" / ") }
export const renderReplacementOption = ({ value }) => value.type === "BYE" ? "BYE" : (
  <div>{replacementPeople(value).map((person, index) => <div key={index}>
    {person.profileId
      ? <PlayerIdentity player={person} to={null} interactive={false}><strong>{participantDescription(person)}</strong></PlayerIdentity>
      : <>
        <PlayerIdentity player={person} to={null} interactive={false}><strong>{replacementName(person)} #{person.userId}</strong></PlayerIdentity>
        <div className="small" title={participantLocation(person?.location).country || undefined}>{replacementFacts(person)}</div>
      </>}
  </div>)}</div>
)
